import { FC, ReactNode, useMemo } from 'react'
import { Navigate, Route, Routes } from 'react-router'
import r from 'routes'

import SignIn from '@/pages/authentication/sign-in'
import SSOCallback from '@/pages/authentication/sign-in/SSOCallback'
import SignUp from '@/pages/authentication/sign-up'
import { useAuthSelector } from '@/store'

import ErrorCard from '../error-card'
import useWebex from './useWebex'
import useZoom from './useZoom'

type Props = {
  children: ReactNode
}

const EmbeddedApp: FC<Props> = ({ children }) => {
  const { token } = useAuthSelector()

  const [, webexError] = useWebex()
  const [, zoomError] = useZoom()

  const error = useMemo(() => webexError || zoomError, [webexError, zoomError])

  if (error) {
    if (error.code === 'ACCOUNT_EXISTS') {
      return (
        <div className="flex justify-center w-full pt-32">
          <ErrorCard
            title="You're not yet authorized"
            description={
              <>
                <p>Please contact an account administrator to be granted admin access.</p>
                <p className="mt-4 text-xs">In the meantime, you can use the agent functionality.</p>
              </>
            }
          />
        </div>
      )
    }

    return <ErrorCard title="An error occurred" description={error.error} />
  }

  if (!token) {
    return window.isStandalone ? (
      <Routes>
        <Route path={r.root} Component={SignIn} />
        <Route path={r.authentication.signUp} Component={SignUp} />
        <Route path={r.sso.callback} Component={SSOCallback} />
        <Route
          path="*"
          Component={() => (
            <Navigate to={r.root + (window.location.pathname === r.root ? window.location.search : '')} replace />
          )}
        />
      </Routes>
    ) : null
  }

  return <>{children}</>
}

export default EmbeddedApp
